class Cookie
{
    set(name, value, expires, path) {
        var cookieStr = name + "=" + escape(value) + "; ";
        
        if (expires) {
            var today = new Date();
            var expr = new Date(today.getTime() + expires * 24 * 60 * 60 * 1000);
            expires = expr.toGMTString();
            cookieStr += "expires=" + expires + "; ";
        }

        if (path) {
            cookieStr += "path=" + path + "; ";
        }

        console.log('Set cookie', cookieStr);
        document.cookie = cookieStr;
    }

    isSet(name) {
        console.log('document.cookie', document.cookie, document.cookie.indexOf(name + '=') > -1);
        
        return document.cookie.indexOf(name + '=') > -1;
    }

    hasValue(name, value) {
        return document.cookie.indexOf(name + '=' + value) > -1;
    }
}

export default new Cookie(); 